const setupVideoSlider = function( element ) {

	jQuery( element ).slick({
		arrows: true,
		centerMode: true,
		infinite: true,
		centerPadding: '100px',
		slidesToShow: 3,
		speed: 500,
		dots: false,
		prevArrow: '.js-acf-video-slider-prev',
		nextArrow: '.js-acf-video-slider-next',

		responsive: [{

      breakpoint: 979,
      settings: {
				slidesToShow: 3,
      }

    }, {

      breakpoint: 781,
      settings: {
				slidesToShow: 1,
      }

    }]

	});

}


const api = {
	setupVideoSlider: setupVideoSlider
};

export default api;